import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";
import { CompPackOrderRentalValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderRentalValues";
import { RentalItem } from "../../../Models/Rental/RentalItem";
import { AxDropdown } from "@axess/limestone";
import { AxCheck } from "../../../Components/AxForm/AxCheck";
import { PriceHelper } from "../../../Lib/Helper/PriceHelper";
import { CultureInfo } from "../../../Models/Culture/CultureInfo";

export interface ICompPackBookingRentalOptionsInitData {
    rentalItems: RentalItem[];
    cultureInfo: CultureInfo;
}

@ModuleName("CompPackBookingRentalOptions")
export class CompPackBookingRentalOptions implements AxInit {
    protected rentalItems: RentalItem[];
    protected complexPackageBookingOptions: ComplexPackageBookingOptions;
    protected pickUpLocationDropdown: AxDropdown = new AxDropdown();
    protected checkBoxesAdditionalRentalItems: AxCheck[];
    protected priceHelper: PriceHelper;

    private identifierAdditionalRentalCheckbox = "identifierAdditionalRentalCheckbox_";

    AxInit(init: ICompPackBookingRentalOptionsInitData): void {

        this.priceHelper = new PriceHelper(init.cultureInfo, false);

        this.complexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");

        this.checkBoxesAdditionalRentalItems = [];

        // not used currently but needed in the future
        //this.setUpPickupLocationDropdown();

        this.rentalItems = JSON.parse(init.rentalItems.toString());

        this.addRentalValues();

        this.initCheckBoxesAdditionalItems();
    }

    // addRentalValues
    addRentalValues() {
        for (let rentalItem of this.rentalItems) {
            if (!rentalItem.isOptional) {
                const rentalValues = new CompPackOrderRentalValues(rentalItem.rentalItemNr, rentalItem.rentalPersTypeNr, rentalItem.packagePositionNr);
                this.complexPackageBookingOptions.bookingValues.rentalOrderValues.push(rentalValues);
            }
        }
    }

    // initCheckBoxes
    initCheckBoxesAdditionalItems() {
        $('.compPack_additionalRental_item_check').parent().each((i, obj) => {
            let id = $(obj).find('.compPack_additionalRental_item_check').attr('data-rentalItem-id');
            this.checkBoxesAdditionalRentalItems.push(new AxCheck(this.identifierAdditionalRentalCheckbox + id, obj));
        });

        $('.compPack_additionalRental_item_check').change((object) => {
            this.checkAdditionalItemsChecked();
        });

        // initial check
        this.checkAdditionalItemsChecked();
    }

    // checkAdditionalItemsChecked
    checkAdditionalItemsChecked() {
        this.complexPackageBookingOptions.bookingValues.additionalRentalOrderValues = new Array<CompPackOrderRentalValues>();

        const packagePrice: number = + $('#compPackBookingPackagePrice').attr('data-packagePrice') / 100;
        let additionalPrice = 0;

        let additionalItemsSelected = 0;

        $('.compPack_additionalRental_item_check').each((i, obj) => {
            let check = $(obj).prop('checked');
            let rentalItemId: number = + $(obj).attr('data-rentalItem-id');
            let personType: number = + $(obj).attr('data-rental-personType');
            let packagePositionNr: number = + $(obj).attr('data-rental-packagePositionNr');

            let additionalRentalItem = $(`#additionalRentalItem_${rentalItemId}_${personType}_${packagePositionNr}`);

            if (check) {
                let additionalRentalOrder = new CompPackOrderRentalValues(rentalItemId, personType, packagePositionNr);
                this.complexPackageBookingOptions.bookingValues.additionalRentalOrderValues.push(additionalRentalOrder);

                $(additionalRentalItem).show();

                if (!$(additionalRentalItem).hasClass('d-flex')) {
                    $(additionalRentalItem).addClass('d-flex');
                }

                let rentalItemPrice: number = + $(additionalRentalItem).attr('data-rentalItem-price') / 100;
                additionalPrice += rentalItemPrice;

                additionalItemsSelected++;
            } else {
                $(additionalRentalItem).hide();
                $(additionalRentalItem).removeClass('d-flex');
            }
        });

        if (additionalItemsSelected > 0) {
            $('#additionalRentalItemsDivider').show();
        } else {
            $('#additionalRentalItemsDivider').hide();
        }

        if (additionalPrice > 0) {
            let newPrice = additionalPrice + packagePrice;

            $('#compPackBookingPriceSum').html('' + this.priceHelper.GetPriceStringWithCurrencySymbol(newPrice));
        } else {
            $('#compPackBookingPriceSum').html('' + this.priceHelper.GetPriceStringWithCurrencySymbol(packagePrice));
        }
    }

    // setUpPickupLocationDropdown
    setUpPickupLocationDropdown() {
        this.pickUpLocationDropdown.init('.prod_selection__pickup-selection .ax-form-select');
        this.complexPackageBookingOptions.dropDowns.push(this.pickUpLocationDropdown);

        // Pickup
        $('.prod_selection__pickup-selection').on('click', (x) => {
            $('.compPack_bookingOption_pickup_select').toggleClass('active');
        });

        $('.compPack_bookingOption_rentalLocation_option').on('click', (x) => {
            let locationId = $(x.target).attr('data-value');
            this.complexPackageBookingOptions.bookingValues.pickupLocationId = Number(locationId);
            $('.compPack_bookingOption_pickup_select').removeClass('active');
        });
    }


}